import { $touchMode } from "../../state/touch";

/**
 * The phone keyboard covers half a landscape screen, and position: fixed does not shrink for it. The visible
 * height goes into --vvh for the touch panels and the chat, and a field focused in a panel is scrolled into
 * view once the keyboard has opened (spec 2p §2.5, §3.5).
 */
export function bindViewport(win: Window = window): void {
  const vv = win.visualViewport;
  const set = () => document.documentElement.style.setProperty("--vvh", `${Math.round(vv ? vv.height : win.innerHeight)}px`);
  set();
  (vv ?? win).addEventListener("resize", set);
  document.addEventListener("focusin", (e) => {
    const t = e.target as HTMLElement | null;
    if (!$touchMode.get() || !t?.closest?.(".panel")) return;
    setTimeout(() => t.scrollIntoView?.({ block: "center" }), 300);
  });
}
